import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Header from "components/header";
import Logo_0 from "./Logo_0.png";
import Logo_1 from "./Logo_1.png";
import Logo_2 from "./Logo_2.png";
import Logo_3 from "./Logo_3.png";
import Logo_4 from "./Logo_4.png";
import Logo_5 from "./Logo_5.png";
import Logo_6 from "./Logo_6.png";
import Logo_7 from "./Logo_7.png";
import Logo_8 from "./Logo_8.png";
export const _frontmatter = {
  "title": "Imprint"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header title="Imprint" mdxType="Header" />
    <section className="content container">
      <div className="columns">
        <div className="is-offset-1 is-9 column mb-6" data-aos="fade-up">
          <h2>{`Publisher`}</h2>
          <p>{`responsAbility Investments AG`}<br parentName="p"></br>{`
`}{`Zollstrasse 17, 8005 Zurich`}<br parentName="p"></br>{`
`}{`Phone +41 44 403 05 00`}<br parentName="p"></br>{`
`}<a parentName="p" {...{
              "href": "mailto:info@responsAbility.com"
            }}>{`info@responsAbility.com`}</a>{`  `}</p>
          <h3>{`Visit us at`}</h3>
          <a href="https://www.responsability.com" target="_blank">www.responsability.com</a>
          <h2>{`PUBLISHING INFORMATION`}</h2>
          <p><strong parentName="p">{`Texts:`}</strong>{` Pedro Fernandez, Paul Hailey, Stacy Fiehler, Jonathan Pfaender`}</p>
          <p><strong parentName="p">{`Editor`}</strong>{`: Stacy Fiehler`}</p>
          <p><strong parentName="p">{`Research:`}</strong>{` Laura Dean, Mette Emsholm Kjaer, Jessica Malms, David Mazaira`}</p>
          <p><strong parentName="p">{`Concept and design`}</strong>{`: Joppe Berlin`}</p>
          <p><em parentName="p">{`Since 2016, responsAbility has been offsetting the carbon emissions of its activities.`}</em></p>
          <h2>{`Building the impact investing industry`}</h2>
          <p>{`Our commitment to market initiatives`}</p>
          <div className="columns is-8 is-offest-2 column is-vcentered is-mobile">
            <div className="column is-4">
              <img src={Logo_8} alt="Logo_8" />
            </div>
            <div className="column is-4">
              <img src={Logo_4} alt="Logo_4" />
            </div>
            <div className="column is-4">
    <img src={Logo_0} alt="Logo_0" />
            </div>
            <div className="column is-4">
    <img src={Logo_3} alt="Logo_3" />
            </div>
            <div className="column is-4">
              <img src={Logo_7} alt="Logo_7" />
            </div>
            <div className="column is-4">
    <img src={Logo_1} alt="Logo_1" />
            </div>
            <div className="column is-4">
    <img src={Logo_5} alt="Logo_5" />
            </div>
            <div className="column is-4">
              <img src={Logo_2} alt="Logo_2" />
            </div>
            <div className="column is-4">
              <img src={Logo_6} alt="Logo_6" />
            </div>
          </div>
          <h2>{`Sources:`}</h2>
          <ul>
            <li parentName="ul"><strong parentName="li">{`Where we are going`}</strong>{` – Global Warming of 1.5 ºC, Intergovernmental Panel on Climate Change, 2018`}</li>
            <li parentName="ul"><strong parentName="li">{`Move Fast and Fix Things`}</strong>{` – Ericsson Mobility Report, 2020; The Inclusive Internet Index 2020, Economist Intelligence Unit`}</li>
            <li parentName="ul"><strong parentName="li">{`Level the Playing Field`}</strong>{` – Global Gender Gap Report 2020, World Economic Forum; World Population Prospects, United Nations, 2019; World Bank, 2018`}</li>
            <li parentName="ul"><strong parentName="li">{`Under the Same Roof`}</strong>{` – United Nations, 2012; UN Global Status Report 2017; Global Warming of 1.5 ºC, Intergovernmental Panel on Climate Change, 2018; C40 Cities, 2020`}</li>
            <li parentName="ul"><strong parentName="li">{`Sustainable Cities`}</strong>{` -  International Energy Agency (IEA), 2020; US Department of Energy, 2020`}</li>
          </ul>
          <h2>{`Photo Credits:`}</h2>
          <ul>
            <li parentName="ul">
              <p parentName="li"><strong parentName="p">{`Coverphoto:`}</strong>{` Verena Brüning/verenabruening.de`}</p>
            </li>
            <li parentName="ul">
              <p parentName="li"><strong parentName="p">{`Timeline:`}</strong>{` `}</p>
              <ul parentName="li">
                <li parentName="ul"><strong parentName="li">{`Hillary Clinton:`}</strong>{` Hum Images/Alamy Stock Photo `}</li>
              </ul>
            </li>
            <li parentName="ul">
              <p parentName="li"><strong parentName="p">{`Paul Haily:`}</strong>{` Geri Krischker`}</p>
            </li>
            <li parentName="ul">
              <p parentName="li"><strong parentName="p">{`Man in glasshouse with tablet:`}</strong>{` Henk Badenhorst/Getty Images, `}</p>
            </li>
            <li parentName="ul">
              <p parentName="li"><strong parentName="p">{`Woman with headscarf and green plants:`}</strong>{` Eri Miura/Getty Images,`}</p>
            </li>
            <li parentName="ul">
              <p parentName="li"><strong parentName="p">{`Pedro Fernandez:`}</strong>{` responsAbility,`}</p>
            </li>
            <li parentName="ul">
              <p parentName="li"><strong parentName="p">{`Marie-Anna Benard:`}</strong>{` David Maurel, `}</p>
            </li>
            <li parentName="ul">
              <p parentName="li"><strong parentName="p">{`Mathew:`}</strong>{` responsAbility, `}</p>
            </li>
            <li parentName="ul">
              <p parentName="li"><strong parentName="p">{`Rosa Maria:`}</strong>{` shutterstock.com, `}</p>
            </li>
            <li parentName="ul">
              <p parentName="li"><strong parentName="p">{`Lily:`}</strong>{` responsAbility`}</p>
            </li>
            <li parentName="ul">
              <p parentName="li"><strong parentName="p">{`All other photos:`}</strong>{` shutterstock.com`}</p>
            </li>
          </ul>
          <h2>{`Disclaimer`}</h2>
          <p>{`This information material was produced by responsAbility Investments AG (responsAbility) and/or its affiliates with the greatest of care and  to the best of its knowledge and belief. However, responsAbility Investments AG provides no guarantee with regard to its content and completeness and does not accept any liability for losses which might arise from making use of this information. The opinions expressed in this information material are those of responsAbility Investments AG at the time of writing and are subject to change at any time without notice. If nothing is indicated to the contrary, all figures are unaudited. This information material is provided for information purposes only and is for the exclusive use of the recipient. It does not constitute an offer or a recommendation to buy or sell financial instruments or services. This information material may not be reproduced either in part or in full without the written permission of responsAbility. It is expressly not intended for persons who, due to their nationality or place of residence, are not permitted access to such information under local law. `}</p>
        </div>
      </div>
    </section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      